interface mcOptions {
    offsetWidth: number;
    offsetHeight: number;
    cx: number;
    cy: number;
    cz: number;
    x: number;
    y: number;
    scale: number;
    alpha: number;
}

interface ballOptions {
    radius?: number;
    dtr?: number;
    d?: number;
    mcList?: Array<mcOptions>;
    active?: boolean;
    lasta?: number;
    lastb?: number;
    distr?: boolean;
    tspeed?: number;
    size?: number;
    mouseX?: number;
    mouseY?: number;
    howElliptical?: number;
    aA?: null | NodeListOf<HTMLElement>;
    wrapper: string;
}

interface defaultOptions {
    radius: number;
    dtr: number;
    d: number;
    mcList: Array<mcOptions>;
    active: boolean;
    lasta: number;
    lastb: number;
    distr: boolean;
    tspeed: number;
    size: number;
    mouseX: number;
    mouseY: number;
    howElliptical: number;
    aA: null | NodeListOf<HTMLElement>;
    oDiv: null | HTMLElement;
    wrapper: string
}

export default class Ball {
    public options = {
        radius: 300,
        dtr: Math.PI / 180,
        d: 300,
        mcList: [],
        active: false,
        lasta: 1,
        lastb: 1,
        distr: true,
        tspeed: 2,
        size: 250,
        mouseX: 0,
        mouseY: 0,
        howElliptical: 1,
        aA: null,
        oDiv: null,
        wrapper: ''
    } as defaultOptions

    public timeId: null | number = null 

    constructor (options: ballOptions) {
        this.options = Object.assign(this.options, options)
        this.init()
    }

    init (): void {

        this.options.oDiv = document.querySelector(this.options.wrapper) as HTMLElement
        this.options.radius = this.options.oDiv.getBoundingClientRect().width / 2 - 20
        
        this.options.aA = this.options.oDiv.querySelectorAll('span') as NodeListOf<HTMLElement>;
        const _this = this
        const oDiv = this.options.oDiv
        const aA: NodeListOf<HTMLElement> = this.options.aA


        aA.forEach((node: HTMLElement, idx: number) => {
            this.options.mcList.push({
                offsetWidth: node.getBoundingClientRect().width,
                offsetHeight: node.getBoundingClientRect().height,
                cx: 0,
                cy: 0,
                cz: 0,
                x: 0,
                y: 0,
                scale: 1,
                alpha: 1
            } as mcOptions)
        })
        
        this.sineCosine(0, 0, 0)
        
        this.positionAll()

        oDiv.addEventListener('touchstart', (e) => {
            e.stopPropagation()
            _this.options.active = true
        })

        oDiv.addEventListener('touchend', (e) => {
            e.stopPropagation()
            _this.options.active = false
        })

        oDiv.addEventListener('touchmove', (e) => {
            e.stopPropagation()
            var oEvent: any = e.targetTouches[0]
            
            let mouseX = oEvent.pageX - (oDiv.offsetLeft + oDiv.offsetWidth / 2)
            let mouseY = oEvent.pageY - (oDiv.offsetTop + oDiv.offsetHeight / 2)
            
            _this.options.mouseX = mouseX
            _this.options.mouseY = mouseY
        })
        
        this.timeId = setInterval(() => {
            this.update()
        }, 30);
    }

    sineCosine (a: number, b: number, c: number) {
        const dtr = this.options.dtr
        return {
            sa: Math.sin(a * dtr),
            ca: Math.cos(a * dtr),
            sb: Math.sin(b * dtr),
            cb: Math.cos(b * dtr),
            sc: Math.sin(c * dtr),
            cc: Math.cos(c * dtr)
        }
    }

    doPosition () {
        const oDiv = this.options.oDiv as HTMLElement
        const aA = this.options.aA as NodeListOf<HTMLElement>
        const l:number = oDiv.offsetWidth / 2
        const t:number = oDiv.offsetHeight / 2
        const mcList = this.options.mcList
        const len =  mcList.length
        for (let i=0; i < len; i++) {
            const trans = `translate3d(${mcList[i].cx + l- mcList[i].offsetWidth / 2}px, ${mcList[i].cy + t - mcList[i].offsetHeight / 2}px, 0) scale(${mcList[i].scale})`
            aA[i].style.webkitTransform = trans
            aA[i].style.transform = trans
            aA[i].style.opacity = `${mcList[i].alpha}`
        }
    }

    positionAll () {
        const oDiv = this.options.oDiv as HTMLElement
        const aA = this.options.aA as NodeListOf<HTMLElement>
        const mcList = this.options.mcList
        const distr = this.options.distr
        const radius = this.options.radius
        let phi = 0
        let theta = 0
        let max = mcList.length
        
        var aTmp = []
        var oFragment = document.createDocumentFragment()

        for(let i = 0; i < aA.length; i++) {
            aTmp.push(aA[i])
        }
        
        aTmp.sort(() => {
            return Math.random() < 0.5 ? 1 : -1
        })
        
        for(let i = 0; i < aTmp.length; i++) {
            oFragment.appendChild(aTmp[i])
        }
        
        oDiv.appendChild(oFragment)
        
        for(let i = 1; i < max+1; i++) {
            if (distr) {
                phi = Math.acos(-1 + (2 * i - 1) / max)
                theta = Math.sqrt(max * Math.PI) * phi
            } else {
                phi = Math.random() * (Math.PI)
                theta = Math.random() * (2 * Math.PI)
            }
            //坐标变换
            mcList[i-1].cx = radius * Math.cos(theta) * Math.sin(phi)
            mcList[i-1].cy = radius * Math.sin(theta) * Math.sin(phi)
            mcList[i-1].cz = radius * Math.cos(phi)

            const trans = `translate3d(${mcList[i - 1].cx + oDiv.offsetWidth / 2 - mcList[i-1].offsetWidth / 2}px, ${mcList[i - 1].cy + oDiv.offsetHeight / 2 - mcList[i-1].offsetHeight / 2}px, 0)`
            aA[i-1].style.webkitTransform = trans
            aA[i-1].style.transform = trans
        }
    }

    depthSort () {
        const mcList = this.options.mcList
        const aA = this.options.aA as NodeListOf<HTMLElement>
        var aTmp = []
        
        for(let i = 0; i < mcList.length; i++) {
            aTmp.push(mcList[i])
        }
        
        aTmp.sort((vItem1, vItem2) => {
            if(vItem1.cz > vItem2.cz) {
                return -1
            } else if(vItem1.cz < vItem2.cz) {
                return 1
            } else {
                return 0
            }
        })
        
        for (let i = 0; i < aTmp.length; i++) {
            aA[i].style.zIndex = `${i}`
        }
    }

    update () {
        let { active, mouseY, mouseX, size, radius, tspeed, lasta, lastb, mcList, howElliptical, d } = this.options
        var a
        var b
        
        if (active) {
            a = (-Math.min( Math.max( -mouseY, -size ), size) / radius) * tspeed
            b = (Math.min( Math.max( -mouseX, -size ), size) / radius) * tspeed
        } else {
            a = lasta * 0.98;
            b = lastb * 0.98;
        }
        
        lasta = a
        lastb = b
        
        if (Math.abs(a)<=0.01 && Math.abs(b)<=0.01) {
            return
        }
        
        var c = 0
        const {sa, ca, cb, sb, cc, sc} = this.sineCosine(a,b,c)
        for (var j = 0; j < mcList.length; j++) {
            var rx1 = mcList[j].cx
            var ry1 = mcList[j].cy * ca + mcList[j].cz * (-sa)
            var rz1 = mcList[j].cy * sa + mcList[j].cz * ca
            
            var rx2 = rx1 * cb + rz1 * sb
            var ry2 = ry1
            var rz2 = rx1 * (-sb) + rz1 * cb
            
            var rx3 = rx2 * cc + ry2 * (-sc)
            var ry3 = rx2 * sc + ry2 * cc
            var rz3 = rz2
            
            mcList[j].cx = rx3
            mcList[j].cy = ry3
            mcList[j].cz = rz3
            
            let per = d / (d + rz3)
            
            mcList[j].x = (howElliptical * rx3 * per) - (howElliptical * 2)
            mcList[j].y = ry3 * per
            mcList[j].scale = per * 1.1
            mcList[j].alpha = per
            
            mcList[j].alpha = (mcList[j].alpha - 0.6) * (10 / 6)
        }   
        this.doPosition()
        this.depthSort()
    }

    destroy () {
        if (this.timeId) {
            clearInterval(this.timeId)
            this.timeId = null
        }
    }

}